import ExpandableChartCard from "../../../../shared/charts/ExpandableChartCard";
import ComboChart from "./ComboChart";

/**
 * Monthly Billables — Actual vs Forecast (restored to the legacy
 * ComboChart style per user request). Past months are emerald bars
 * with the value label on top; future months render as a dashed
 * forecast line + soft area fill; the break-even target appears as
 * a horizontal dashed line.
 *
 * Values are expressed in thousands of SEK ("K kr") for readability.
 */
export default function MonthlyBillingChart({ data, canSee, breakEven, mondaySourced, right }) {
  if (!canSee) return null;
  // Billing rows carry full SEK values; ComboChart prefers k-SEK units so
  // we divide each series by 1000 and use unit="€K".
  const actual = Array(12).fill(null);
  const forecast = Array(12).fill(null);
  let lastActualIdx = -1;
  for (let i = 0; i < 12; i++) {
    const row = data?.[i];
    const a = row?.Actual;
    if (a != null && a > 0) {
      actual[i] = Math.round(Number(a) / 1000);
      lastActualIdx = i;
    }
  }
  for (let i = Math.max(0, lastActualIdx); i < 12; i++) {
    const row = data?.[i];
    // Prefer Forecast, fall back to Contract (the plan/expected value).
    const f = row?.Forecast ?? row?.Contract;
    if (f != null) forecast[i] = Math.round(Number(f) / 1000);
  }
  if (lastActualIdx >= 0 && forecast[lastActualIdx] == null && actual[lastActualIdx] != null) {
    forecast[lastActualIdx] = actual[lastActualIdx];
  }
  const targetK = Math.round(Number(breakEven || 100000) / 1000);

  return (
    <ExpandableChartCard
      title="Monthly Billables — Actual vs Forecast"
      subtitle={`Monthly billed revenue · Target ${targetK}K kr/mo${mondaySourced ? " · 🔄 from Monday" : ""}`}
      right={right}
      renderChart={({ expanded }) => (
        <>
          <ComboChart
            actual={actual}
            forecast={forecast}
            target={targetK}
            unit="€K"
            label="billing"
            height={expanded ? 360 : 220}
            actualColor="#10c981"
            forecastColor="#34d399"
            targetColor="#f59e0b"
          />
          <Legend />
        </>
      )}
    />
  );
}

function Legend() {
  return (
    <div className="flex items-center gap-4 mt-2 text-[11px] text-rc-text-secondary">
      <span className="inline-flex items-center gap-1.5"><span className="w-3 h-1 rounded-sm bg-[#10c981]"/> Actual</span>
      <span className="inline-flex items-center gap-1.5"><span className="w-4 h-px border-t border-dashed border-[#34d399]"/> Forecast</span>
      <span className="inline-flex items-center gap-1.5"><span className="w-4 h-px border-t border-dashed border-[#f59e0b]"/> Target</span>
    </div>
  );
}
